"use strict";
'use es6'; // resource type

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PUBLIC_ACCESS_RULES_ENABLED = exports.PUBLIC_ACCESS_RULES = exports.WEEKLY_NOTIFICATION_EMAIL_ID = exports.USES_DEFAULT_TEMPLATE = exports.USE_FEATURED_IMAGE_IN_SUMMARY = exports.URL_BASE = exports.UPDATED_DATE_TIME = exports.UPDATED = exports.SUBSCRIPTION_LISTS_BY_TYPE = exports.SUBSCRIPTION_FORM_GUID = exports.SUBSCRIPTION_CONTACTS_PROPERTY = exports.SOCIAL_ACCOUNT_TWITTER = exports.SLUG = exports.SITE_ID = exports.SHOW_SUMMARY_IN_RSS = exports.SHOW_SUMMARY_IN_LISTING = exports.SHOW_SUMMARY_IN_EMAILS = exports.SHOW_SOCIAL_LINK_TWITTER = exports.SHOW_SOCIAL_LINK_LINKEDIN = exports.SHOW_SOCIAL_LINK_FACEBOOK = exports.ROOT_URL = exports.RESOLVED_DOMAIN = exports.PUBLISH_DATE_FORMAT = exports.PUBLIC_TITLE = exports.POSTS_PER_RSS_FEED = exports.POSTS_PER_LISTING_PAGE = exports.POST_HTML_HEAD = exports.POST_HTML_FOOTER = exports.PORTAL_ID = exports.NAME = exports.MONTHLY_NOTIFICATION_EMAIL_ID = exports.MONTH_FILTER_FORMAT = exports.LIVE_DOMAIN = exports.LISTING_TEMPLATE_PATH = exports.LISTING_LAYOUT_ID = exports.LANGUAGE = exports.ITEM_TEMPLATE_PATH = exports.ITEM_TEMPLATE_IS_SHARED = exports.ITEM_LAYOUT_ID = exports.INSTANT_NOTIFICATION_EMAIL_ID = exports.ID = exports.HTML_TITLE = exports.HTML_KEYWORDS = exports.HTML_HEAD_IS_SHARED = exports.HTML_HEAD = exports.HTML_FOOTER_IS_SHARED = exports.HTML_FOOTER = exports.ENABLE_GOOGLE_AMP_OUTPUT = exports.EMAIL_API_SUBSCRIPTION_ID = exports.DOMAIN_WHEN_PUBLISHED = exports.DOMAIN = exports.DESCRIPTION = exports.DELETED_AT = exports.DEFAULT_NOTIFICATION_REPLY_TO = exports.DEFAULT_NOTIFICATION_FROM_NAME = exports.DEFAULT_GROUP_STYLE_ID = exports.DAILY_NOTIFICATION_EMAIL_ID = exports.CREATED_DATE_TIME = exports.CREATED = exports.COS_EXTENSION_RESOURCE = exports.COMMENT_VERIFICATION_TEXT = exports.COMMENT_SHOULD_CREATE_CONTACT = exports.COMMENT_NOTIFICATION_EMAILS = exports.COMMENT_MODERATION = exports.COMMENT_MAX_THREAD_DEPTH = exports.COMMENT_FORM_GUID = exports.COMMENT_DATE_FORMAT = exports.CLOSE_COMMENTS_OLDER = exports.CATEGORY_ID = exports.ATTACHED_STYLESHEETS = exports.ANALYTICS_PAGE_ID = exports.AMP_LOGO_WIDTH = exports.AMP_LOGO_SRC = exports.AMP_LOGO_HEIGHT = exports.AMP_LOGO_ALT = exports.AMP_LINK_COLOR = exports.AMP_HEADER_FONT_SIZE = exports.AMP_HEADER_FONT = exports.AMP_HEADER_COLOR = exports.AMP_HEADER_BACKGROUND_COLOR = exports.AMP_CUSTOM_CSS = exports.AMP_BODY_FONT_SIZE = exports.AMP_BODY_FONT = exports.AMP_BODY_COLOR = exports.ALLOW_COMMENTS = exports.ABSOLUTE_URL = exports.BLOG = void 0;
var BLOG = 'Blog'; // property keys

exports.BLOG = BLOG;
var ABSOLUTE_URL = 'absoluteUrl';
exports.ABSOLUTE_URL = ABSOLUTE_URL;
var ALLOW_COMMENTS = 'allowComments';
exports.ALLOW_COMMENTS = ALLOW_COMMENTS;
var AMP_BODY_COLOR = 'ampBodyColor';
exports.AMP_BODY_COLOR = AMP_BODY_COLOR;
var AMP_BODY_FONT = 'ampBodyFont';
exports.AMP_BODY_FONT = AMP_BODY_FONT;
var AMP_BODY_FONT_SIZE = 'ampBodyFontSize';
exports.AMP_BODY_FONT_SIZE = AMP_BODY_FONT_SIZE;
var AMP_CUSTOM_CSS = 'ampCustomCss';
exports.AMP_CUSTOM_CSS = AMP_CUSTOM_CSS;
var AMP_HEADER_BACKGROUND_COLOR = 'ampHeaderBackgroundColor';
exports.AMP_HEADER_BACKGROUND_COLOR = AMP_HEADER_BACKGROUND_COLOR;
var AMP_HEADER_COLOR = 'ampHeaderColor';
exports.AMP_HEADER_COLOR = AMP_HEADER_COLOR;
var AMP_HEADER_FONT = 'ampHeaderFont';
exports.AMP_HEADER_FONT = AMP_HEADER_FONT;
var AMP_HEADER_FONT_SIZE = 'ampHeaderFontSize';
exports.AMP_HEADER_FONT_SIZE = AMP_HEADER_FONT_SIZE;
var AMP_LINK_COLOR = 'ampLinkColor';
exports.AMP_LINK_COLOR = AMP_LINK_COLOR;
var AMP_LOGO_ALT = 'ampLogoAlt';
exports.AMP_LOGO_ALT = AMP_LOGO_ALT;
var AMP_LOGO_HEIGHT = 'ampLogoHeight';
exports.AMP_LOGO_HEIGHT = AMP_LOGO_HEIGHT;
var AMP_LOGO_SRC = 'ampLogoSrc';
exports.AMP_LOGO_SRC = AMP_LOGO_SRC;
var AMP_LOGO_WIDTH = 'ampLogoWidth';
exports.AMP_LOGO_WIDTH = AMP_LOGO_WIDTH;
var ANALYTICS_PAGE_ID = 'analyticsPageId';
exports.ANALYTICS_PAGE_ID = ANALYTICS_PAGE_ID;
var ATTACHED_STYLESHEETS = 'attachedStylesheets';
exports.ATTACHED_STYLESHEETS = ATTACHED_STYLESHEETS;
var CATEGORY_ID = 'categoryId';
exports.CATEGORY_ID = CATEGORY_ID;
var CLOSE_COMMENTS_OLDER = 'closeCommentsOlder';
exports.CLOSE_COMMENTS_OLDER = CLOSE_COMMENTS_OLDER;
var COMMENT_DATE_FORMAT = 'commentDateFormat';
exports.COMMENT_DATE_FORMAT = COMMENT_DATE_FORMAT;
var COMMENT_FORM_GUID = 'commentFormGuid';
exports.COMMENT_FORM_GUID = COMMENT_FORM_GUID;
var COMMENT_MAX_THREAD_DEPTH = 'commentMaxThreadDepth';
exports.COMMENT_MAX_THREAD_DEPTH = COMMENT_MAX_THREAD_DEPTH;
var COMMENT_MODERATION = 'commentModeration';
exports.COMMENT_MODERATION = COMMENT_MODERATION;
var COMMENT_NOTIFICATION_EMAILS = 'commentNotificationEmails';
exports.COMMENT_NOTIFICATION_EMAILS = COMMENT_NOTIFICATION_EMAILS;
var COMMENT_SHOULD_CREATE_CONTACT = 'commentShouldCreateContact';
exports.COMMENT_SHOULD_CREATE_CONTACT = COMMENT_SHOULD_CREATE_CONTACT;
var COMMENT_VERIFICATION_TEXT = 'commentVerificationText';
exports.COMMENT_VERIFICATION_TEXT = COMMENT_VERIFICATION_TEXT;
var COS_EXTENSION_RESOURCE = 'cos_extension_resource';
exports.COS_EXTENSION_RESOURCE = COS_EXTENSION_RESOURCE;
var CREATED = 'created';
exports.CREATED = CREATED;
var CREATED_DATE_TIME = 'createdDateTime';
exports.CREATED_DATE_TIME = CREATED_DATE_TIME;
var DAILY_NOTIFICATION_EMAIL_ID = 'dailyNotificationEmailId';
exports.DAILY_NOTIFICATION_EMAIL_ID = DAILY_NOTIFICATION_EMAIL_ID;
var DEFAULT_GROUP_STYLE_ID = 'defaultGroupStyleId';
exports.DEFAULT_GROUP_STYLE_ID = DEFAULT_GROUP_STYLE_ID;
var DEFAULT_NOTIFICATION_FROM_NAME = 'defaultNotificationFromName';
exports.DEFAULT_NOTIFICATION_FROM_NAME = DEFAULT_NOTIFICATION_FROM_NAME;
var DEFAULT_NOTIFICATION_REPLY_TO = 'defaultNotificationReplyTo';
exports.DEFAULT_NOTIFICATION_REPLY_TO = DEFAULT_NOTIFICATION_REPLY_TO;
var DELETED_AT = 'deletedAt';
exports.DELETED_AT = DELETED_AT;
var DESCRIPTION = 'description';
exports.DESCRIPTION = DESCRIPTION;
var DOMAIN = 'domain';
exports.DOMAIN = DOMAIN;
var DOMAIN_WHEN_PUBLISHED = 'domainWhenPublished';
exports.DOMAIN_WHEN_PUBLISHED = DOMAIN_WHEN_PUBLISHED;
var EMAIL_API_SUBSCRIPTION_ID = 'emailApiSubscriptionId';
exports.EMAIL_API_SUBSCRIPTION_ID = EMAIL_API_SUBSCRIPTION_ID;
var ENABLE_GOOGLE_AMP_OUTPUT = 'enableGoogleAmpOutput';
exports.ENABLE_GOOGLE_AMP_OUTPUT = ENABLE_GOOGLE_AMP_OUTPUT;
var HTML_FOOTER = 'htmlFooter';
exports.HTML_FOOTER = HTML_FOOTER;
var HTML_FOOTER_IS_SHARED = 'htmlFooterIsShared';
exports.HTML_FOOTER_IS_SHARED = HTML_FOOTER_IS_SHARED;
var HTML_HEAD = 'htmlHead';
exports.HTML_HEAD = HTML_HEAD;
var HTML_HEAD_IS_SHARED = 'htmlHeadIsShared';
exports.HTML_HEAD_IS_SHARED = HTML_HEAD_IS_SHARED;
var HTML_KEYWORDS = 'htmlKeywords';
exports.HTML_KEYWORDS = HTML_KEYWORDS;
var HTML_TITLE = 'htmlTitle';
exports.HTML_TITLE = HTML_TITLE;
var ID = 'id';
exports.ID = ID;
var INSTANT_NOTIFICATION_EMAIL_ID = 'instantNotificationEmailId';
exports.INSTANT_NOTIFICATION_EMAIL_ID = INSTANT_NOTIFICATION_EMAIL_ID;
var ITEM_LAYOUT_ID = 'itemLayoutId';
exports.ITEM_LAYOUT_ID = ITEM_LAYOUT_ID;
var ITEM_TEMPLATE_IS_SHARED = 'itemTemplateIsShared';
exports.ITEM_TEMPLATE_IS_SHARED = ITEM_TEMPLATE_IS_SHARED;
var ITEM_TEMPLATE_PATH = 'itemTemplatePath';
exports.ITEM_TEMPLATE_PATH = ITEM_TEMPLATE_PATH;
var LANGUAGE = 'language';
exports.LANGUAGE = LANGUAGE;
var LISTING_LAYOUT_ID = 'listingLayoutId';
exports.LISTING_LAYOUT_ID = LISTING_LAYOUT_ID;
var LISTING_TEMPLATE_PATH = 'listingTemplatePath';
exports.LISTING_TEMPLATE_PATH = LISTING_TEMPLATE_PATH;
var LIVE_DOMAIN = 'liveDomain';
exports.LIVE_DOMAIN = LIVE_DOMAIN;
var MONTH_FILTER_FORMAT = 'monthFilterFormat';
exports.MONTH_FILTER_FORMAT = MONTH_FILTER_FORMAT;
var MONTHLY_NOTIFICATION_EMAIL_ID = 'monthlyNotificationEmailId';
exports.MONTHLY_NOTIFICATION_EMAIL_ID = MONTHLY_NOTIFICATION_EMAIL_ID;
var NAME = 'name';
exports.NAME = NAME;
var PORTAL_ID = 'portalId';
exports.PORTAL_ID = PORTAL_ID;
var POST_HTML_FOOTER = 'postHtmlFooter';
exports.POST_HTML_FOOTER = POST_HTML_FOOTER;
var POST_HTML_HEAD = 'postHtmlHead';
exports.POST_HTML_HEAD = POST_HTML_HEAD;
var POSTS_PER_LISTING_PAGE = 'postsPerListingPage';
exports.POSTS_PER_LISTING_PAGE = POSTS_PER_LISTING_PAGE;
var POSTS_PER_RSS_FEED = 'postsPerRssFeed';
exports.POSTS_PER_RSS_FEED = POSTS_PER_RSS_FEED;
var PUBLIC_TITLE = 'publicTitle';
exports.PUBLIC_TITLE = PUBLIC_TITLE;
var PUBLISH_DATE_FORMAT = 'publishDateFormat';
exports.PUBLISH_DATE_FORMAT = PUBLISH_DATE_FORMAT;
var RESOLVED_DOMAIN = 'resolvedDomain';
exports.RESOLVED_DOMAIN = RESOLVED_DOMAIN;
var ROOT_URL = 'rootUrl';
exports.ROOT_URL = ROOT_URL;
var SHOW_SOCIAL_LINK_FACEBOOK = 'showSocialLinkFacebook';
exports.SHOW_SOCIAL_LINK_FACEBOOK = SHOW_SOCIAL_LINK_FACEBOOK;
var SHOW_SOCIAL_LINK_LINKEDIN = 'showSocialLinkLinkedin';
exports.SHOW_SOCIAL_LINK_LINKEDIN = SHOW_SOCIAL_LINK_LINKEDIN;
var SHOW_SOCIAL_LINK_TWITTER = 'showSocialLinkTwitter';
exports.SHOW_SOCIAL_LINK_TWITTER = SHOW_SOCIAL_LINK_TWITTER;
var SHOW_SUMMARY_IN_EMAILS = 'showSummaryInEmails';
exports.SHOW_SUMMARY_IN_EMAILS = SHOW_SUMMARY_IN_EMAILS;
var SHOW_SUMMARY_IN_LISTING = 'showSummaryInListing';
exports.SHOW_SUMMARY_IN_LISTING = SHOW_SUMMARY_IN_LISTING;
var SHOW_SUMMARY_IN_RSS = 'showSummaryInRss';
exports.SHOW_SUMMARY_IN_RSS = SHOW_SUMMARY_IN_RSS;
var SITE_ID = 'siteId';
exports.SITE_ID = SITE_ID;
var SLUG = 'slug';
exports.SLUG = SLUG;
var SOCIAL_ACCOUNT_TWITTER = 'socialAccountTwitter';
exports.SOCIAL_ACCOUNT_TWITTER = SOCIAL_ACCOUNT_TWITTER;
var SUBSCRIPTION_CONTACTS_PROPERTY = 'subscriptionContactsProperty';
exports.SUBSCRIPTION_CONTACTS_PROPERTY = SUBSCRIPTION_CONTACTS_PROPERTY;
var SUBSCRIPTION_FORM_GUID = 'subscriptionFormGuid';
exports.SUBSCRIPTION_FORM_GUID = SUBSCRIPTION_FORM_GUID;
var SUBSCRIPTION_LISTS_BY_TYPE = 'subscriptionListsByType';
exports.SUBSCRIPTION_LISTS_BY_TYPE = SUBSCRIPTION_LISTS_BY_TYPE;
var UPDATED = 'updated';
exports.UPDATED = UPDATED;
var UPDATED_DATE_TIME = 'updatedDateTime';
exports.UPDATED_DATE_TIME = UPDATED_DATE_TIME;
var URL_BASE = 'urlBase';
exports.URL_BASE = URL_BASE;
var USE_FEATURED_IMAGE_IN_SUMMARY = 'useFeaturedImageInSummary';
exports.USE_FEATURED_IMAGE_IN_SUMMARY = USE_FEATURED_IMAGE_IN_SUMMARY;
var USES_DEFAULT_TEMPLATE = 'usesDefaultTemplate';
exports.USES_DEFAULT_TEMPLATE = USES_DEFAULT_TEMPLATE;
var WEEKLY_NOTIFICATION_EMAIL_ID = 'weeklyNotificationEmailId';
exports.WEEKLY_NOTIFICATION_EMAIL_ID = WEEKLY_NOTIFICATION_EMAIL_ID;
var PUBLIC_ACCESS_RULES = 'publicAccessRules';
exports.PUBLIC_ACCESS_RULES = PUBLIC_ACCESS_RULES;
var PUBLIC_ACCESS_RULES_ENABLED = 'publicAccessRulesEnabled';
exports.PUBLIC_ACCESS_RULES_ENABLED = PUBLIC_ACCESS_RULES_ENABLED;